"use client"

import { ttFirsNeue } from "@/fonts"

import { cn } from "@/lib/utils"

import React from "react"
import ReactMarkdown from "react-markdown"
import BannerDisclosure from "./banner"

type Props = {}

const Disclosure = () => {
  const markdown = `
  The information on this website and any of our social media pages or other information outlets (collectively the “Website”) has been prepared and/or published by us Mythos Venture Partners (collectively with its affiliates, “Mythos Venture Partners” “we,” “our,” or “us”) without taking into account your objectives, financial situation or needs. For this reason, you must, before acting on any information, have regards to your objectives, financial situation and needs, and seek appropriate professional advice by consulting with your own investment, legal, tax and/or similar professionals regarding your specific situation and any specific decisions concerning any investment as nothing in the website is intended to provide any tax, legal, or investment advice to you.

  \n &nbsp;

  All information on the Website is provided for information purposes only. Any descriptions of any investments, portfolio companies or fund terms noted on the Website are only a summary of certain investments and terms set forth by the funds managed by us and they do not contain the full terms of, or all information relevant to, the investments. You must consider the relevant product disclosure statements and terms and conditions of each product or service before trading or subscribing for any product or service.

  \n &nbsp;
  
  You must not rely on this information when making investments decisions. All investment decisions are at your own risk and we will not be liable to you for any losses you may incur whatsoever and howsoever arising.

  \n &nbsp;

  No information on this Website constitutes, or should be considered to constitute, an offer to sell, a solicitation of an offer to buy, or a recommendation of any security or any other product or services to you (including any interest in any investment vehicle or financial product sponsored, managed, discussed or mentioned by us). We do not intend to solicit the general public and we do not, and will not, make our services available to the general public.
  
  \n &nbsp;

  Furthermore, such offers or solicitations will only be made by us separately and directly to you by means of the confidential offering documents, which should be read in their entirety.

  \n &nbsp;
  
  Any comments about a specific company or investment product on our Website are not intended to be construed as a recommendation. All such information is not directed to you, or any other investor or potential investor. We make no implied or express recommendations concerning the manner in which we should or would handle your account, as investment strategies depend on your investment objectives.

  \n &nbsp;
  
  Some information on the Website may be sourced from third party providers, or link to third party products and services. We do not give any representation or warranty as to the currency, reliability, accuracy or completeness of any third party material and we accept no responsibility for errors or omissions in that third party material or any material that is available or accessible by following a link on the Website to a third party site

  \n &nbsp;
  
  Past performance is no guarantee of future performance.

  \n &nbsp;
  
  Investing in products of the nature referred to on the Website carries significant risk (including the risk that your entire invested monies may be lost) and is not suitable for all investors. We give no assurances, representations or warranties whatsoever that investment objectives will be achieved or investment strategies will be successful.

  \n &nbsp;

  Any forecasts, predictive statements or projections on the Website represents the individual views and opinion of the individual analyst(s) who have made those forecasts, predictive statements or projections and not of Mythos Ventures Fund I. Any such forecasts, predictive statements or projections are based on assumptions and expectations that the relevant analyst(s) considered relevant tat the time of publishing and may change without notice and without us updating the information on the Website. We do not endorse the comments of any company representatives, analysts or third parties made on the Website, in posts (including podcasts, videos, blogs and social media) or given during interviews or otherwise. We do not endorse the performance of any of the forementioned persons' companies, strategies and modelling.

  \n &nbsp;

  Charts or other graphics displaying historical prices may have been adjusted for the purposes of contriving an outcome or demonstrating an opinion. Adjusted prices may differ to actual historical prices when looking at an investment’s course of sales or historical closing prices.

  \n &nbsp;

  You must ensure that you are permitted to invest in any goods or services offered by us, depending on your residency status and other qualifying terms under the relevant government securities laws. You indemnify us for any loss or damage we may suffer as a result of you not properly disclosing your eligibility to invest. You must advise us if you will hold any investments or products, or engage with any services, for any other person. 

  \n &nbsp;

  You may not copy, reproduce, distribute, display, sell or in any way exploit this information on the Website.
  `

  return (
    <div className="w-full mt-[65px] md:mt-[90px] px-[1px] items-center flex flex-col gap-6 md:gap-12">
      <BannerDisclosure />
      <div className="flex flex-col gap-6 w-full md:w-[40vw]">
        <div
          className={cn(
            "text-white text-3xl xl:text-[55px] font-medium xl:leading-[63px]",
            ttFirsNeue.className
          )}
        >
          {`Disclaimer`}
        </div>
        <div className="border-b border-[#4A4A4A]"></div>
        <div className="flex flex-col gap-3 xl:gap-6">
          <article className="prose-p:text-[#ccc] prose-p:text-xs xl:prose-p:text-xl prose-h3:text-white prose-p:leading-[24px] xl:prose-p:leading-[31px] prose-h3:text-sm xl:prose-h3:text-[22px] prose-h3:leading-6 xl:prose-h3:leading-10">
            <ReactMarkdown>{markdown}</ReactMarkdown>
          </article>
        </div>
        <div className="border-b border-[#4A4A4A]"></div>
      </div>
    </div>
  )
}

export default Disclosure
